import { gql, useMutation } from '@apollo/client'
import { IUserProfile, IUserProfileInput } from '@dtos/User'

export const USER_UPDATE = gql`
  mutation UserUpdate($attributes: UserProfileInputObject!) {
    userUpdate(
      input: { attributes: $attributes, clientMutationId: "user-update" }
    ) {
      user {
        id
        firstName
        lastName
        email
        phone
        ddi
        extraPhone
        cpf
        rg
        bornAt
        skype
        companyName
        companyPosition
        biography
        twitter
        facebook
        coverImageUrl
        locale
        address {
          id
          country
          street
          number
          complement
          city
          state
          zipCode
          district
        }
        customFields {
          slug
          type
          label
          value
        }
      }
      errors
    }
  }
`

interface IUserUpdateResult {
  userUpdate: {
    user: IUserProfile | null
    errors: string[]
  }
}

export const useUserUpdate = () => {
  const [updateUser, { loading, error }] = useMutation<IUserUpdateResult>(
    USER_UPDATE,
    { refetchQueries: ['getProfile'] },
  )

  const handleUpdateUser = async (attributes: IUserProfileInput) => {
    const response = await updateUser({ variables: { attributes } })
    return response.data?.userUpdate
  }

  return { handleUpdateUser, loading, error }
}
